export enum CardMode {
    DARK = '#424242',
    LIGHT = '#FFFFFF',
    AUTO = 'Auto',
}
